// Number formatting helper shared by ExtraPackage card components.
// `normalizeNumberLocale` rewrites the app's `zh` locale to `zh-TW` so
// `Intl.NumberFormat` picks the desired (Taiwan) thousands separators
// instead of falling back to the browser default for `zh`.

export function formatLocalizedNumber(value: number, locale: string): string {
  return new Intl.NumberFormat(normalizeNumberLocale(locale)).format(value)
}

function normalizeNumberLocale(locale: string): string {
  if (locale === 'zh') return 'zh-TW'
  return locale
}
